export default {
  cn: [{
    version: '2.2.0',
    time: '2022.06.20',
    changes: [
      '重构内部实现',
      '调整样式风格',
      '增加函数式功能入口，<kbd>DialogAlert</kbd>、<kbd>DialogModal</kbd>、<kbd>DialogToast</kbd>、<kbd>DialogMask</kbd> 与 <kbd>DialogHelper</kbd>',
      '修复关闭 <kbd class="kbd-code">mask</kbd> 窗口时没有显示动画',
      '增加全局滚动条管理',
      '修复 <kbd class="kbd-code">modal</kbd> 模式最大化后，窗口内容区域没有最大化的问题',
      '增加 <kbd class="kbd-code">modal</kbd> 的 <kbd>fullscreen</kbd> prop，以最大化方式打开窗口',
      '增加 <kbd class="kbd-code">alert</kbd>、<kbd class="kbd-code">toast</kbd> 标题文本溢出切割'
    ]
  }, {
    version: '2.1.3',
    time: '2019.10.26',
    changes: [
      '使用 <b>render</b> 函数的方式完全重构插件',
      '修改 prop <b>dialogCloseButton</b> 名称为 <b>closeButton</b>',
      '修改 prop <b>dialogMaxButton</b> 名称为 <b>maxButton</b>',
      '新增 prop <b>icon</b>，设置是否显示消息类型图标',
      '新增 prop <b>customClass</b>，设置自定义样式的类名',
      '新增 prop <b>shaking</b>，设置对话框外部区域点击时，是否显示抖动的动画',
      '使用 <b>Javascript Standard</b> 语法标准对项目进行格式化'
    ]
  }, {
    version: '2.0.1',
    time: '2018.12.28',
    changes: [
      '重构插件',
      '增加部分参数可全局配置',
      '增加 <code>instanceName</code> 参数在全局注册插件时配置名称',
      '默认插件实例名称从 <code>$vDialog</code> 精简为 <code>$dlg</code>',
      '修改 <strong>iconfont</strong> 的字体名称，以免与实际项目中的字体名称冲突',
      '多语言增加葡萄牙语(Portuguese)',
      '完善窗口动画及背景遮罩动画',
      '<strong>Alert</strong>, <strong>Mask</strong>, <strong>Toast</strong> 三种方式的参数设置允许自由组合',
      '修复 <strong>IE9</strong> 下 <strong>Toast</strong> 的位置不正确的问题',
      '调整 <strong>Modal</strong> 模式下关闭窗口的 <strong>API</strong>'
    ]
  }, {
    version: '1.9.0',
    time: '2018.04.22',
    changes: [
      '修复连续弹出和关闭窗口时，最后一个窗口不会被关闭的问题'
    ]
  }, {
    version: '1.0.0 - 1.8.0',
    time: '2018.03-2018.04',
    changes: [
      '开发并发布基于<strong>Vue2.x</strong> 的 <code>v-dialogs</code> 插件'
    ]
  }],
  en: [{
    version: '2.2.0',
    time: '2022.06.20',
    changes: [
      'Refactoring internal implementations',
      'Adjust the dialogs style',
      'Add functional entry, <kbd>DialogAlert</kbd>, <kbd>DialogModal</kbd>, <kbd>DialogToast</kbd>, <kbd>DialogMask</kbd> and <kbd>DialogHelper</kbd>',
      'Fixed no animation when closing <kbd class="kbd-code">mask</kbd> dialog',
      'Fixed when <kbd class="kbd-code">modal</kbd> dialog maximized, the dialog content area is not maximized',
      'Add global scroll bar management',
      'Add <kbd>fullscreen</kbd> property in <kbd class="kbd-code">modal</kbd> dialog, maximize when opening modal dialog',
      'Add <kbd class="kbd-code">alert</kbd>, <kbd class="kbd-code">toast</kbd> header text overflow truncate'
    ]
  }, {
    version: '2.1.3',
    time: '2019.10.26',
    changes: [
      'Use <b>render functions</b> to completely refactored plugin',
      'Modify prop name from <b>dialogCloseButton</b> to <b>closeButton</b>',
      'Modify prop name <b>dialogMaxButton</b> to <b>maxButton</b>',
      'Added prop <b>icon</b>, config to whether display message type icon',
      'Added prop <b>customClass</b>, custom them class name',
      'Added prop <b>shaking</b>, config to whether display a shaking animation when clicking outside of dialog',
      'Use <b>Javascript Standard</b> Style to format code'
    ]
  }, {
    version: '2.0.1',
    time: '2018.12.28',
    changes: [
      'Rebuild plugin',
      'Set some options can config in plugin install(Vue.use)',
      'Added <code>instanceName</code> option, set plugin instance name in plugin install(Vue.use)',
      'The default plugin instance name change from <code>$vDialog</code> to <code>$dlg</code>',
      'Change icon font name and class name, avoid conflicts with ICON font content in the user environment',
      'Added Portuguese language',
      'Perfect dialog and overlay animation',
      '<strong>Alert</strong>, <strong>Mask</strong>, <strong>Toast</strong> call options allow free combination',
      'Fixed <strong>Toast</strong> position incorrect issue in <strong>IE9</strong>',
      'Adjust <strong>Modal</strong> mode close dialog <strong>API</strong>'
    ]
  }, {
    version: '1.9.0',
    time: '2018.04.22',
    changes: [
      'Fixed the last window will not be closed when continuously popping and closing the window.'
    ]
  }, {
    version: '1.0.0 - 1.8.0',
    time: '2018.03-2018.04',
    changes: [
      'Develop and publish <code>v-dialogs</code> plugin for <strong>Vue2.x</strong>.'
    ]
  }]
}
